/**
 * 路由 主入口
 * @author LiQingSong
 * 路由参数说明：
 * path: '/home'                  链接 -  /home 内部路由 /^(https?:|mailto:|tel:)/.test(path)外链
 * hidden: true                   如果设置为 true ，项目将不会显示在 “导航栏” (默认为 false)
 * redirect: ''                   重定向
 * name:'router-name'             路由名称
 * meta : {
    roles: ['admin','editor']    权限控制页面角色(您可以设置多个角色), 不设置此参数 默认 所有角色都有权限
    title: 'title'               名称显示在侧栏和面包屑、浏览器title(推荐设置)
    icon: 'icon-class'           图标显示在侧栏中
    breadcrumb: [                面包屑内容：1、默认不配置按照路由自动读取；2、false,按照路由自动读取讲不读取此；3、配置对应的面包屑格式如下：
          {
            meta: { title: '标题' },   必填
            linkpath: '/demo',         链接 -  /demo 内部路由 /^(https?:|mailto:|tel:)/.test(path)外链 , 可不写
          }
    ],
    activeMenu: '/example/list'  侧栏选中，如果设置路径，侧栏将突出显示你设置的路径，默认 router.path
    belongTopMenu: '/news'       所属顶级菜单,用于选中顶部菜单，与菜单切换，默认不设置 path.split('/') 第1个；
                                            三级此参数的作用是选中顶级菜单 ，二级此参数的作用是所属某个顶级菜单的下面，两个层级的必须同时填写一致
  }
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// 引入Index框架
import LayoutIndex from '@/layout/Index'
import LayoutIndexHome from '@/layout/Index/Home'

/**
 * 固定路由
 * 没有权限要求的路由
 * 所有角色可访问
 */
export const constantRoutes = [
  {
    path: '/login',
    meta: {
      title: '登录'
    },
    component: () => import('@/views/Login'),
    hidden: true
  },

  {
    path: '/404',
    meta: {
      title: 'Not Found'
    },
    component: () => import('@/views/404'),
    hidden: true
  },

  {
    path: '/',
    redirect: '/home',
    component: LayoutIndexHome,
    meta: { title: '首页', icon: 'home' },
    children: [
      {
        path: 'home',
        name: 'home',
        hidden: true,
        component: () => import('@/views/Home/index'),
        meta: { title: '首页', icon: 'control', activeMenu: '/' }
      },
      {
        path: 'home/wh',
        hidden: true,
        component: () => import('@/views/WhHome/index'),
        // component: () => import('@/views/Home/index'),
        meta: { title: '首页', icon: 'control', activeMenu: '/' }
      },
      {
        path: 'home/wh2',
        hidden: true,
        component: () => import('@/views/WhHome2/index'),
        // component: () => import('@/views/Home/index'),
        meta: { title: '首页', icon: 'control', activeMenu: '/' }
      },
      {
        path: 'home/ls',
        hidden: true,
        component: () => import('@/views/LsHome/index'),
        // component: () => import('@/views/Home/index'),
        meta: { title: '首页', icon: 'control', activeMenu: '/' }
      },
      {
        path: 'home/my1',
        hidden: true,
        component: () => import('@/views/MyHome1/index'),
        // component: () => import('@/views/Home/index'),
        meta: { title: '首页', icon: 'control', activeMenu: '/' }
      },
      {
        path: 'home/my2',
        hidden: true,
        component: () => import('@/views/MyHome2/index'),
        // component: () => import('@/views/Home/index'),
        meta: { title: '首页', icon: 'control', activeMenu: '/' }
      },
      {
        path: 'home/hs',
        hidden: true,
        component: () => import('@/views/HsHome/index'),
        // component: () => import('@/views/Home/index'),
        meta: { title: '首页', icon: 'control', activeMenu: '/' }
      },
      {
        path: 'home/qingyuan',
        hidden: true,
        component: () => import('@/views/Homes/Qingyuan/index'),
        // component: () => import('@/views/Home/index'),
        meta: { title: '首页', icon: 'control', activeMenu: '/' }
      },
      {
        path: 'home/hzyt',
        hidden: true,
        component: () => import('@/views/Huizeyuntian/index'),
        // component: () => import('@/views/Home/index'),
        meta: { title: '首页', icon: 'control', activeMenu: '/' }
      },
      {
        path: 'home/gl',
        hidden: true,
        component: () => import('@/views/Home/Ganluo/index'),
        meta: { title: '首页', icon: 'control', activeMenu: '/' }
      },
      {
        path: 'home/hj',
        hidden: true,
        component: () => import('@/views/Homes/Huajiao/index'),
        meta: { title: '首页', icon: 'control', activeMenu: '/' }
      },
      {
        path: 'home/jiangbei',
        hidden: true,
        component: () => import('@/views/Homes/Jiangbei/index'),
        // component: () => import('@/views/Home/index'),
        meta: { title: '首页', icon: 'control', activeMenu: '/' }
      },
      {
        path: 'home/shouan',
        hidden: true,
        component: () => import('@/views/Homes/Shouan/index'),
        // component: () => import('@/views/Home/index'),
        meta: { title: '首页', icon: 'control', activeMenu: '/' }
      },
      {
        path: 'home/quanjiao',
        hidden: true,
        component: () => import('@/views/Homes/Quanjiao/index'),
        meta: { title: '首页', icon: 'control', activeMenu: '/' }
      },
      {
        path: 'home/ningnan',
        hidden: true,
        component: () => import('@/views/Homes/Ningnan/index'),
        meta: { title: '首页', icon: 'control', activeMenu: '/' }
      },
      {
        path: 'home/jxtjkj',
        redirect: '/tele/images',
        hidden: true
      },
      {
        path: 'home/shenuo',
        hidden: true,
        component: () => import('@/views/Homes/zhihui/index'),
        meta: { title: '首页', icon: 'control', activeMenu: '/' }
      },
      {
        path: 'home/preview',
        hidden: true,
        component: () => import('@/views/Homes/Preview/index'),
        meta: { title: '首页', icon: 'control', activeMenu: '/' }
      },
      {
        path: 'home/lwc',
        hidden: true,
        component: () => import('@/views/Homes/LWC/index'),
        // component: () => import('@/views/Home/index'),
        meta: { title: '首页', icon: 'control', activeMenu: '/' }
      },
      {
        path: 'home/lw',
        hidden: true,
        component: () => import('@/views/Homes/LW/index'),
        // component: () => import('@/views/Home/index'),
        meta: { title: '首页', icon: 'control', activeMenu: '/' }
      }
    ]
  },

  {
    path: '/tele',
    redirect: '/tele/dashboard',
    component: LayoutIndex,
    meta: { title: '虫情测报灯', icon: 'light' },
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/Telemetry/dashboardV2/index'),
        name: 'TeleDashboard',
        meta: { title: '预警盘', icon: 'spores' }
      },
      // {
      //   path: 'insects',
      //   component: () => import('@/views/Telemetry/_insect/index'),
      //   name: 'insects',
      //   meta: { title: '虫情观察' }
      // },
      {
        path: 'labels',
        component: () => import('@/views/Telemetry/label/index'),
        name: 'LabelImage',
        meta: {
          title: '昆虫标注',
          roles: ['admin', 'label', 'qingyuan'],
          icon: 'label'
        }
      },
      {
        path: 'images',
        component: () => import('@/views/Telemetry/images/index'),
        name: 'images',
        meta: { title: '图像列表', icon: 'camera-1' }
      },
      {
        path: 'reports',
        component: () => import('@/views/Telemetry/report/index'),
        name: 'TeleReports',
        meta: { title: '数据报表', icon: 'statics' }
      }
    ]
  },
  {
    path: '/monitor',
    redirect: '/monitor/video',
    component: LayoutIndex,
    meta: { title: '远程监控', icon: 'camera' },
    children: [
      {
        path: 'video',
        hidden: true,
        component: () => import('@/views/Monitor/index'),
        name: 'monitor',
        meta: { title: '实时监控', icon: 'camera', activeMenu: '/monitor' }
      }
    ]
  },
  {
    path: '/me',
    component: LayoutIndex,
    meta: {},
    hidden: true,
    children: [
      {
        path: '',
        hidden: true,
        component: () => import('@/views/Auth/info'),
        name: 'me'
      }
    ]
  },
  {
    path: '/screen',
    hidden: true,
    component: () => import('@/layout/Index/LayoutScreen.vue'),
    children: [
      {
        path: 'jiangbei',
        hidden: true,
        component: () => import('@/views/Screen/JiangbeiScreen/screen'),
        name: 'screen-jiangbei'
      },
      {
        path: 'focus/table/large',
        hidden: true,
        component: () => import('@/views/Screen/Tb/Large'),
        name: 'screen-focus'
      },
      {
        path: 'focus/table/small',
        hidden: true,
        component: () => import('@/views/Screen/Tb/Small'),
        name: 'screen-table'
      }
    ]
  }
]

/**
 * 异步路由
 * 需要根据用户角色动态加载的路由
 */
export const asyncRoutes = [
  // 引入其他模块路由
  // componentRouter,
  // pagesampleRouter,
  // chartstatisticRouter,
  {
    path: '/meteorology',
    redirect: '/meteorology/dashboard',
    component: LayoutIndex,
    meta: {
      title: '气象墒情',
      icon: 'water-drop',
      exRoles: ['sdmf'],
      excludes: [96]
    },
    children: [
      {
        path: 'dashboard',
        hidden: true,
        component: () => import('@/views/Meteorology/index'),
        name: 'MeteDashboard',
        meta: { title: '趋势分析', icon: 'control', activeMenu: '/meteorology' }
      }
    ]
  },
  {
    path: '/trap',
    redirect: '/trap/dashboard',
    component: LayoutIndex,
    meta: {
      title: '电子性诱',
      icon: 'traps',
      roles: ['admin', 'AllPages', 'drpmics', 'drpc', 'tianchang', 'wh01']
    },
    children: [
      {
        path: 'dashboard',
        hidden: true,
        component: () => import('@/views/Trap/index'),
        name: 'TrapDashboard',
        meta: { title: '预警盘', icon: 'control', activeMenu: '/trap' }
      }
      // {
      //   path: 'report',
      //   component: () => import('@/views/Trap/report'),
      //   name: 'TrapReports',
      //   meta: { title: '数据报表', icon: 'control' }
      // }
    ]
  },
  {
    path: '/camera-trap',
    redirect: '/camera-trap/dashboard',
    component: LayoutIndex,
    meta: {
      title: '性诱色诱',
      icon: 'traps',
      roles: ['admin', 'AllPages', 'drpwm-syrb']
    },
    children: [
      {
        path: 'dashboard',
        hidden: true,
        component: () => import('@/views/CameraTrap/index'),
        name: 'CameraTrapDashboard',
        meta: { title: '预警盘', icon: 'control', activeMenu: '/camera-trap' }
      }
    ]
  },
  {
    path: '/ruibao',
    redirect: '/ruibao/dashboard',
    component: LayoutIndex,
    meta: {
      title: '睿宝盆',
      icon: 'gibberella',
      roles: ['admin', 'AllPages']
    },
    children: [
      {
        path: 'dashboard',
        hidden: true,
        component: () => import('@/views/Ruibao/index'),
        name: 'RuibaoDashboard',
        meta: { title: '预警盘', icon: 'control', activeMenu: '/ruibao' }
      }
    ]
  },
  {
    path: '/wheat-scab',
    redirect: '/wheat-scab/dashboard',
    component: LayoutIndex,
    meta: {
      title: '赤霉病预警仪',
      icon: 'gibberella',
      roles: ['admin', 'AllPages', 'tianchang']
    },
    children: [
      {
        path: 'dashboard',
        hidden: true,
        component: () => import('@/views/WheatScab/index'),
        name: 'WeatScabDashboard',
        meta: { title: '预警盘', activeMenu: '/wheat-scab' }
      }
    ]
  },
  {
    path: '/spores',
    redirect: '/spores/images',
    component: LayoutIndex,
    meta: {
      title: '孢子捕捉仪',
      icon: 'spores',
      roles: ['admin', 'AllPages', 'wh01', 'wh021', 'tianchang']
    },
    children: [
      {
        path: 'images',
        hidden: true,
        component: () => import('@/views/Spore/list'),
        name: 'sporeImages',
        meta: { title: '图片列表', icon: 'control', activeMenu: '/spores' }
      }
    ]
  },
  {
    path: '/rodents',
    redirect: '/rodents/images',
    component: LayoutIndex,
    meta: {
      title: '鼠害监测',
      icon: 'mouse',
      roles: [
        'admin',
        'AllPages',
        'wh01',
        'tianchang',
        'qingyuan',
        'drpwm-syrb'
      ]
    },
    children: [
      {
        path: 'images',
        hidden: true,
        component: () => import('@/views/Rodent'),
        name: 'rodentImages',
        meta: { title: '图片列表', icon: 'control', activeMenu: '/rodents' }
      }
    ]
  },
  {
    path: '/survey',
    redirect: '/survey/list',
    component: LayoutIndex,
    meta: {
      title: '移动采集',
      icon: 'survey',
      roles: ['admin', 'AllPages', 'drpmics', 'drpcs', 'drpms']
    },
    children: [
      {
        path: 'list',
        hidden: true,
        component: () => import('@/views/Survey/index'),
        name: 'survey',
        meta: {
          title: '移动采集',
          icon: 'survey',
          activeMenu: '/survey'
        }
      }
    ]
  },
  {
    path: '/samples',
    redirect: '/samples/images',
    component: LayoutIndex,
    meta: { title: '样本展示', icon: 'camera-1', roles: ['admin', 'AllPages'] },
    children: [
      {
        path: 'images',
        hidden: true,
        component: () => import('@/views/Sample/index'),
        name: 'sample',
        meta: {
          title: '样本展示',
          icon: 'camera-1',
          activeMenu: '/samples'
        }
      }
    ]
  },
  {
    path: '/knowledge',
    redirect: '/knowledge/gl',
    component: LayoutIndex,
    meta: { title: '知识库', icon: 'book', companyId: 62 },
    children: [
      {
        path: 'gl',
        hidden: true,
        component: () => import('@/views/Knowledge/index'),
        name: 'knowledge',
        meta: {
          title: '知识库',
          activeMenu: '/knowledge'
        }
      }
    ]
  },
  {
    path: '/epidemic',
    redirect: '/epidemic/index',
    component: LayoutIndex,
    meta: { title: '小麦流行病', icon: 'book', companyId: 82 },
    children: [
      {
        path: 'index',
        hidden: true,
        component: () => import('@/views/Epidemic/index'),
        name: 'epidemic',
        meta: {
          title: '小麦流行病',
          activeMenu: '/epidemic'
        }
      }
    ]
  },
  {
    path: '/late-blight',
    redirect: '/late-blight/index',
    component: LayoutIndex,
    meta: { title: '植物病害', icon: 'book', companyId: 96 },
    children: [
      {
        path: 'index',
        hidden: true,
        component: () => import('@/views/LateBlight/index'),
        name: 'lateBlight',
        meta: {
          title: '病情',
          activeMenu: '/late-blight'
        }
      }
    ]
  },
  {
    path: '/pest-knowledge',
    redirect: '/pest-knowledge/index',
    component: LayoutIndex,
    meta: { title: '害虫知识库', icon: 'bug', roles: ['admin', 'AllPages'] },
    children: [
      {
        path: 'index',
        hidden: true,
        component: () => import('@/views/PestKnowledge/index'),
        name: 'PestKnowledge',
        meta: {
          title: '害虫知识库',
          activeMenu: '/pest-knowledge'
        }
      }
    ]
  },

  { path: '*', redirect: '/404', hidden: true }
]

/*
// 打印对应链接的权限
const consoleLogRouteRoles = (routes, level) => {
   let obj = {};
   routes.map((item, index) => {
      let { meta, children } = item;
      if (!meta) {
        return item;
      }
      let { title, roles } = meta;
      //console.log(meta);
      obj[title + index + '-' + level ] = roles[0] || '';
      // console.log(children);
      if (children) {
        obj = Object.assign(obj, consoleLogRouteRoles(children, level + 1));
      }
   })
   return obj;
}
console.log(JSON.stringify(consoleLogRouteRoles(asyncRoutes, 1)));
*/

const createRouter = () =>
  new VueRouter({
    // mode: 'history', // 启用的话就是去除#
    scrollBehavior: () => ({ y: 0 }),
    base: process.env.BASE_URL,
    routes: constantRoutes
  })

const router = createRouter()

// 细节见: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // 重置路由
}

export default router
